module.exports = {
    "id": "bam",
    "title": "bam",
    "image": "provision/parts/bam/bam.png",
    "info": [
      {
        "text": "Add Bam to your project",
        "image": "provision/parts/bam/bam.png"
      }
    ],
    "exposedVariables": [],
    "codeImage": "provision/parts/bam/bam.png"
  } ;